(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["c-collection-list"] && !Shopify.designMode) return;
  try {
    
  class CollectionFilters {
    constructor(sectionId) {
      /* console.log('🏗️  CollectionFilters constructor called with sectionId:', sectionId); */
      this.sectionId = sectionId;
      this.section = document.querySelector(`[data-section-id="${sectionId}"]`);
      /* console.log('🎯 Found section element:', this.section); */
      this.filterToggle = this.section?.querySelector('[data-filter-toggle]');
      this.filterSidebar = this.section?.querySelector('[data-filter-sidebar]');
      this.filterOverlay = this.section?.querySelector('[data-filter-overlay]');
      this.filterClose = this.section?.querySelector('[data-filter-close]');
      this.productGrid = this.section?.querySelector('[data-product-grid]');
      this.loading = this.section?.querySelector('[data-loading]');

      // Store current sort value for when select gets cloned
      this.currentSortValue = null;

      // Ensure clean state on initialization
      this.ensureCleanState();

      /* console.log('🚀 Calling init method'); */
      this.init();
    }

    ensureCleanState() {
      // Clean up any leftover filter states
      document.body.classList.remove('filter-open');
      if (this.filterSidebar) {
        this.filterSidebar.classList.remove('active');
      }
      if (this.filterOverlay) {
        this.filterOverlay.classList.remove('active');
      }
    }

    init() {
      // Mobile filter toggle
      if (this.filterToggle) {
        this.filterToggle.addEventListener('click', () => this.openFilters());
      }

      // Close filter events (only for mobile)
      if (this.filterClose) {
        this.filterClose.addEventListener('click', () => this.closeFilters());
      }

      if (this.filterOverlay) {
        this.filterOverlay.addEventListener('click', () => this.closeFilters());
      }

      // Ensure filters close on escape key (only for mobile)
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.filterSidebar?.classList.contains('active') && window.innerWidth < 978) {
          this.closeFilters();
        }
      });

      // Clean up on page unload
      window.addEventListener('beforeunload', () => {
        this.ensureCleanState();
      });

      // Handle browser back/forward buttons
      window.addEventListener('popstate', (e) => {
        this.handlePopState();
      });

      // Filter form handling
      /* console.log('🔗 Binding filter events'); */
      this.bindFilterEvents();

      // Price range events
      /* console.log('🎚️  About to bind price range events'); */
      this.bindPriceRangeEvents();
      //console.log('✅ Price range events binding completed');

      // Load more functionality - bind to current button
      this.bindLoadMoreButton();
    }

    bindLoadMoreButton() {
      const loadMoreBtn = this.section?.querySelector('[data-load-more]');
      if (loadMoreBtn) {
        // Remove any existing listeners
        loadMoreBtn.removeEventListener('click', this.handleLoadMore);
        // Add new listener
        loadMoreBtn.addEventListener('click', (e) => this.handleLoadMore(e));
      }
    }

    handleLoadMore = (event) => {
      event.preventDefault();
      const button = event.target;
      const url = button.dataset.url;
      if (!url) return;

      this.showLoading();
      button.style.display = 'none';

      fetch(url, {
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      })
        .then((response) => response.text())
        .then((data) => {
          const parser = new DOMParser();
          const newDocument = parser.parseFromString(data, 'text/html');
          const newGrid = newDocument.querySelector('[data-product-grid]');
          const newLoadMore = newDocument.querySelector('.c-load-more');

          if (newGrid && this.productGrid) {
            // Get only the product cards (exclude load more button and banner blocks from grid)
            const newProducts = Array.from(newGrid.children).filter(
              (child) => !child.classList.contains('c-load-more') && !child.classList.contains('c-banner-block')
            );

            newProducts.forEach((product) => {
              this.productGrid.appendChild(product.cloneNode(true));
            });
          }

          // Update or remove load more button
          const currentLoadMore = this.section.querySelector('.c-load-more');
          if (newLoadMore && currentLoadMore) {
            currentLoadMore.innerHTML = newLoadMore.innerHTML;
            // Re-bind the new button
            this.bindLoadMoreButton();
          } else if (currentLoadMore) {
            // No more pages, remove the button
            currentLoadMore.remove();
          }

          this.hideLoading();
        })
        .catch((error) => {
          console.error('Load more error:', error);
          this.hideLoading();
          button.style.display = 'block';
        });
    };

    openFilters() {
      // Only work on mobile devices
      if (window.innerWidth >= 978) return;

      if (this.filterSidebar && this.filterOverlay) {
        // Move desktop filters to mobile container
        this.moveFiltersToMobile();
        
        // Add active classes to show the filter sidebar
        this.filterSidebar.classList.add('active');
        this.filterOverlay.classList.add('active');

        // Only prevent body scroll, don't use position fixed
        document.body.classList.add('filter-open');

        // Focus trap - focus on the close button if available
        const closeButton = this.filterSidebar.querySelector('[data-filter-close]');
        if (closeButton) {
          setTimeout(() => closeButton.focus(), 100);
        }
      }
    }

    closeFilters() {
      // Only work on mobile devices
      if (window.innerWidth >= 978) return;

      if (this.filterSidebar && this.filterOverlay) {
        // Move filters back to desktop
        this.moveFiltersToDesktop();
        
        // Remove active classes to hide the filter sidebar
        this.filterSidebar.classList.remove('active');
        this.filterOverlay.classList.remove('active');

        // Restore body scroll
        document.body.classList.remove('filter-open');

        // Return focus to toggle button
        if (this.filterToggle) {
          this.filterToggle.focus();
        }
      }
    }

    moveFiltersToMobile() {
      const desktopFilters = this.section?.querySelector('.c-desktop-filters');
      const mobileContainer = this.section?.querySelector('[data-mobile-filters]');
      
      if (desktopFilters && mobileContainer && !mobileContainer.children.length) {
        // Clone the desktop filters to mobile (preserving events)
        const filtersClone = desktopFilters.cloneNode(true);
        mobileContainer.appendChild(filtersClone);
        
        // Re-bind events for the cloned elements
        this.bindFilterEvents();
        this.bindPriceRangeEvents();
        //console.log('📱 Moved filters to mobile container');
      }
    }

    moveFiltersToDesktop() {
      const mobileContainer = this.section?.querySelector('[data-mobile-filters]');
      
      if (mobileContainer) {
        // Clear mobile container
        mobileContainer.innerHTML = '';
        //console.log('🖥️ Cleared mobile filters container');
      }
    }

    bindFilterEvents() {
      // Bind events for both mobile and desktop forms
      const forms = this.section?.querySelectorAll('[data-filter-form]');
      if (!forms || forms.length === 0) return;

      forms.forEach((form) => {
        // Remove existing event listeners to prevent duplicates
        const newForm = form.cloneNode(true);
        form.parentNode.replaceChild(newForm, form);

        // Handle checkbox and radio inputs - primary event handler
        newForm.addEventListener('change', (e) => {
          if (e.target.type === 'checkbox' || e.target.type === 'radio') {
            // Add visual feedback
            this.addFilteringFeedback(e.target);
            // Small delay to ensure DOM state is updated
            setTimeout(() => {
              this.applyFilters();
            }, 50);
          }
        });

        // Handle clicks on labels to ensure they work properly
        newForm.addEventListener('click', (e) => {
          // Handle label clicks (both checkbox label and text label)
          if (
            e.target.matches('label.c-filter-checkbox, label.c-filter-label') ||
            e.target.closest('label.c-filter-checkbox, label.c-filter-label')
          ) {
            const label = e.target.matches('label') ? e.target : e.target.closest('label');
            const input = document.getElementById(label.getAttribute('for'));
            if (input && !input.disabled) {
              // Let the native label behavior handle the click, but ensure our change event fires
              setTimeout(() => {
                this.addFilteringFeedback(input);
                this.applyFilters();
              }, 10);
            }
            return; // Let native behavior continue
          }

          // Handle clicks on filter option containers (excluding inputs and labels)
          if (
            e.target.closest('.c-filter-option') &&
            !e.target.matches(
              'input[type="checkbox"], input[type="radio"], label, .c-checkbox-mark, .c-filter-label span'
            )
          ) {
            const filterOption = e.target.closest('.c-filter-option');
            const input = filterOption.querySelector('input[type="checkbox"], input[type="radio"]');
            if (input && !input.disabled) {
              e.preventDefault();
              input.checked = !input.checked;
              // Trigger change event manually
              const changeEvent = new Event('change', { bubbles: true });
              input.dispatchEvent(changeEvent);
            }
          }
        });

        // Handle price range inputs with debounce - remove auto-apply
        newForm.addEventListener('input', (e) => {
          if (e.target.type === 'number' && e.target.matches('.c-price-input')) {
            // Just store the values, don't auto-apply
            //console.log('Price input changed:', e.target.name, e.target.value);
          }
        });

        // Handle price apply button
        newForm.addEventListener('click', (e) => {
          if (e.target.matches('[data-price-apply]')) {
            e.preventDefault();
            //console.log('Price apply button clicked');
            this.applyFilters(true); // Pass true to indicate this is a price filter action
          }
        });
      });

      // Handle sorting select for both mobile and desktop
      const sortSelects = this.section?.querySelectorAll('[data-sort-select]');
      if (sortSelects && sortSelects.length > 0) {
        sortSelects.forEach((sortSelect) => {
          // Store the current value before cloning
          const currentValue = sortSelect.value;

          // Remove any existing listeners by cloning
          const newSortSelect = sortSelect.cloneNode(true);

          // Restore the value after cloning
          newSortSelect.value = currentValue;

          sortSelect.parentNode.replaceChild(newSortSelect, sortSelect);

          // Add change event listener
          newSortSelect.addEventListener('change', (e) => {
            //console.log('Sort changed to:', e.target.value);
            // Store the new value immediately for applyFilters
            this.currentSortValue = e.target.value;
            this.applyFilters();
          });
        });
      }

      // Handle active filter removal links for both mobile and desktop
      const activeFilters = this.section.querySelectorAll('.c-active-filter');
      activeFilters.forEach((filter) => {
        filter.addEventListener('click', (e) => {
          e.preventDefault();
          this.removeActiveFilter(filter.href);
        });
      });

      // Handle clear all filters for both mobile and desktop
      const clearAllBtns = this.section.querySelectorAll('.c-clear-all');
      clearAllBtns.forEach((clearAllBtn) => {
        clearAllBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.clearAllFilters();
        });
      });
    }

    addFilteringFeedback(element) {
      // Add a subtle loading state to the filter option
      const option = element.closest('.c-filter-option');
      if (option) {
        option.style.opacity = '0.7';
        setTimeout(() => {
          option.style.opacity = '';
        }, 300);
      }
    }

    removeActiveFilter(url) {
      this.showLoading();

      fetch(url, {
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      })
        .then((response) => response.text())
        .then((data) => {
          this.updatePageContent(data, url);
        })
        .catch((error) => {
          console.error('Error removing filter:', error);
          this.hideLoading();
          this.showError('Error removing filter. Please try again.');
        });
    }

    clearAllFilters() {
      const clearUrl = this.section.querySelector('.c-clear-all')?.href;
      if (!clearUrl) return;

      this.showLoading();

      fetch(clearUrl, {
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      })
        .then((response) => response.text())
        .then((data) => {
          this.updatePageContent(data, clearUrl);
        })
        .catch((error) => {
          console.error('Error clearing filters:', error);
          this.hideLoading();
          this.showError('Error clearing filters. Please try again.');
        });
    }

    updatePageContent(data, url) {
      const parser = new DOMParser();
      const newDocument = parser.parseFromString(data, 'text/html');

      // Update main content
      const newContent = newDocument.querySelector('.c-collection-content');
      if (newContent && this.section.querySelector('.c-collection-content')) {
        this.section.querySelector('.c-collection-content').innerHTML = newContent.innerHTML;
        this.bindLoadMoreButton();
      }

      // Update both mobile and desktop filter containers
      const newFiltersContainer = newDocument.querySelector('.c-facets-container');
      if (newFiltersContainer) {
        // Update mobile filters (in sidebar)
        const mobileFiltersContainer = this.section.querySelector('.c-filter-sidebar .c-facets-container');
        if (mobileFiltersContainer) {
          const currentOpenStates = this.preserveFilterStates(mobileFiltersContainer);
          mobileFiltersContainer.innerHTML = newFiltersContainer.innerHTML;
          this.restoreFilterStates(mobileFiltersContainer, currentOpenStates);
        }

        // Update desktop filters (in main content)
        const desktopFiltersContainer = this.section.querySelector('.c-desktop-filters .c-facets-container');
        if (desktopFiltersContainer) {
          const currentOpenStates = this.preserveFilterStates(desktopFiltersContainer);
          desktopFiltersContainer.innerHTML = newFiltersContainer.innerHTML;
          this.restoreFilterStates(desktopFiltersContainer, currentOpenStates);
        }

        this.bindFilterEvents();
        this.bindPriceRangeEvents();
      }

      // Sync sort select values with current URL
      const urlParams = new URLSearchParams(url.split('?')[1] || '');
      const currentSort = urlParams.get('sort_by');
      if (currentSort) {
        const sortSelects = this.section?.querySelectorAll('[data-sort-select]');
        if (sortSelects) {
          sortSelects.forEach((select) => {
            select.value = currentSort;
            //console.log('Synced sort select to:', currentSort);
          });
        }
      }

      // Update URL
      window.history.pushState({}, '', url);

      this.hideLoading();

      // Close mobile filters after applying
      if (window.innerWidth < 978) {
        this.closeFilters();
      }
    }

    handlePopState() {
      // Handle browser back/forward navigation
      this.showLoading();

      fetch(window.location.href, {
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      })
        .then((response) => response.text())
        .then((data) => {
          this.updatePageContent(data, window.location.href);
        })
        .catch((error) => {
          console.error('Error handling browser navigation:', error);
          // Fallback to page reload
          window.location.reload();
        });
    }

    applyFilters(isPriceFilterAction = false) {
      const forms = this.section?.querySelectorAll('[data-filter-form]');
      const sortSelects = this.section?.querySelectorAll('[data-sort-select]');

      if (!forms || forms.length === 0) {
        //console.log('No forms found');
        return;
      }

      const form = forms[0];
      const sortSelect = sortSelects && sortSelects.length > 0 ? sortSelects[0] : null;

      this.showLoading();

      // Create URL parameters from scratch
      const searchParams = new URLSearchParams();

      // Get current URL parameters to preserve search queries
      const currentParams = new URLSearchParams(window.location.search);
      if (currentParams.has('q')) {
        searchParams.set('q', currentParams.get('q'));
      }

      // Handle checkbox filters
      const checkboxes = form.querySelectorAll('input[type="checkbox"]:checked');
      checkboxes.forEach((checkbox) => {
        if (checkbox.name && checkbox.value) {
          searchParams.append(checkbox.name, checkbox.value);
          //console.log('Adding checkbox filter:', checkbox.name, '=', checkbox.value);
        }
      });

      // Handle price range filters ONLY if it's a price filter action
      if (isPriceFilterAction) {
        const dualRangeInputs = form.querySelectorAll('.c-dual-range');
        dualRangeInputs.forEach((input) => {
          if (input.name && input.value) {
            const defaultValue = input.dataset.priceType === 'min' ? '0' : input.getAttribute('max');
            // Only add if value is different from default
            if (input.value !== defaultValue) {
              // Convert from cents to dollars for Shopify filter
              const valueInCents = parseInt(input.value);
              const valueInDollars = (valueInCents / 100).toFixed(2);
              searchParams.set(input.name, valueInDollars);
              //console.log('Adding price filter:', input.name, '=', valueInDollars, '(converted from cents:', valueInCents, ')');
            }
          }
        });
      } else {
        // Preserve existing price filters if they exist
        const existingPriceFilters = ['filter.v.price.gte', 'filter.v.price.lte'];
        existingPriceFilters.forEach((priceParam) => {
          if (currentParams.has(priceParam)) {
            searchParams.set(priceParam, currentParams.get(priceParam));
            //console.log('Preserving existing price filter:', priceParam, '=', currentParams.get(priceParam));
          }
        });
      }

      // Handle sorting
      let sortValue = null;

      // Use stored sort value if available (from sort change event)
      if (this.currentSortValue) {
        sortValue = this.currentSortValue;
        console.log('Using stored sort value:', sortValue);
        // Clear the stored value after using it
        this.currentSortValue = null;
      } else if (sortSelect && sortSelect.value && sortSelect.value !== '') {
        sortValue = sortSelect.value;
        console.log('Using sort select value:', sortValue);
      } else if (currentParams.has('sort_by')) {
        sortValue = currentParams.get('sort_by');
        console.log('Using existing sort from URL:', sortValue);
      }

      if (sortValue) {
        searchParams.set('sort_by', sortValue);
        console.log('Final sort_by being added:', sortValue);
      } else {
        console.log('No sort selected and no existing sort to preserve');
      }

      // Debug sort select state
      if (sortSelect) {
        console.log(
          'Sort select found:',
          sortSelect.id,
          'value:',
          sortSelect.value,
          'options:',
          Array.from(sortSelect.options).map((o) => o.value)
        );
      } else {
        console.log('No sort select found');
      }

      // Build final URL
      const url = `${window.location.pathname}?${searchParams.toString()}`;
      //console.log('Final URL:', url);

      // Make the request
      fetch(url, {
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      })
        .then((response) => response.text())
        .then((data) => {
          this.updatePageContent(data, url);
          this.bindPriceRangeEvents(); // Re-bind price range events after update
        })
        .catch((error) => {
          console.error('Filter error:', error);
          this.hideLoading();
          this.showError('Error applying filters. Please try again.');
        });
    }

    bindPriceRangeEvents() {
      console.log('🔧 bindPriceRangeEvents called');
      console.log('🔍 this.section:', this.section);

      // Handle dual range sliders
      const dualRangeContainers = this.section?.querySelectorAll('.c-dual-range-container');
      console.log('📦 Found dual range containers:', dualRangeContainers?.length || 0);

      dualRangeContainers.forEach((container, index) => {
        console.log(`\n🏷️  Processing container ${index + 1}:`, container);

        const filterParam = container.dataset.filterParam;
        //console.log('🏷️  Filter param:', filterParam);

        const minRange = container.querySelector('.c-dual-range-min');
        const maxRange = container.querySelector('.c-dual-range-max');
        const progress = container.querySelector('.c-dual-range-progress');

/*         console.log('🎚️  Min range element:', minRange);
        console.log('🎚️  Max range element:', maxRange);
        console.log('📊 Progress element:', progress); */

        // Escape dots in the filterParam for CSS selectors
        const escapedFilterParam = filterParam.replace(/\./g, '\\.');
        /* console.log('🔧 Escaped filterParam for CSS:', escapedFilterParam); */

        // Use exact IDs that match the HTML structure
        // HTML generates IDs like: price-min-display-filter.v.price
        // So we need to use the exact escaped filterParam
        const minDisplay = this.section.querySelector(`#price-min-display-${escapedFilterParam}`);
        const maxDisplay = this.section.querySelector(`#price-max-display-${escapedFilterParam}`);
        const minManualInput = this.section.querySelector(`#manual-min-${escapedFilterParam}`);
        const maxManualInput = this.section.querySelector(`#manual-max-${escapedFilterParam}`);
        
        // Check for duplicate elements
        const allMinDisplays = document.querySelectorAll(`#price-min-display-${escapedFilterParam}`);
        const allMaxDisplays = document.querySelectorAll(`#price-max-display-${escapedFilterParam}`);
/*         console.log('🔍 Found min display elements:', allMinDisplays.length);
        console.log('🔍 Found max display elements:', allMaxDisplays.length); */
        
        if (allMinDisplays.length > 1) {
          /* console.warn('⚠️ Multiple min display elements found! This could cause update issues.'); */
          allMinDisplays.forEach((el, index) => {
            /* console.log(`Min Display ${index + 1}:`, el, 'Visible:', window.getComputedStyle(el).display !== 'none'); */
          });
        }
        
        if (allMaxDisplays.length > 1) {
          /* console.warn('⚠️ Multiple max display elements found! This could cause update issues.'); */
          allMaxDisplays.forEach((el, index) => {
            /* console.log(`Max Display ${index + 1}:`, el, 'Visible:', window.getComputedStyle(el).display !== 'none'); */
          });
        }

        /* console.log('� Looking for selectors with filterParam:', filterParam);
        console.log('🔍 Min display selector:', `#price-min-display-${filterParam}`);
        console.log('🔍 Max display selector:', `#price-max-display-${filterParam}`);
        console.log('🔍 Min manual selector:', `#manual-min-${filterParam}`);
        console.log('🔍 Max manual selector:', `#manual-max-${filterParam}`); */

        // Let's also check what IDs actually exist in the DOM
        const allIds = Array.from(this.section.querySelectorAll('[id*="price-"], [id*="manual-"]')).map((el) => el.id);
        /* console.log('🆔 All price/manual IDs found in DOM:', allIds); */

        // Updated logs with escaped selectors
        /* console.log('🔍 Updated Min display selector (escaped):', `#price-min-display-${escapedFilterParam}`);
        console.log('🔍 Updated Max display selector (escaped):', `#price-max-display-${escapedFilterParam}`);
        console.log('🔍 Updated Min manual selector (escaped):', `#manual-min-${escapedFilterParam}`);
        console.log('🔍 Updated Max manual selector (escaped):', `#manual-max-${escapedFilterParam}`);

        console.log('✅ POST-ESCAPE Min display element:', minDisplay);
        console.log('✅ POST-ESCAPE Max display element:', maxDisplay);
        console.log('✅ POST-ESCAPE Min manual input:', minManualInput);
        console.log('✅ POST-ESCAPE Max manual input:', maxManualInput);

        console.log('�💰 Min display element:', minDisplay);
        console.log('💰 Max display element:', maxDisplay);
        console.log('✏️  Min manual input:', minManualInput);
        console.log('✏️  Max manual input:', maxManualInput); */

        if (!minRange || !maxRange || !progress) {
          /* console.error('❌ Missing essential elements, skipping this container'); */
          return;
        }

        const maxValue = parseInt(minRange.max);
        /* console.log('🎯 Max value from range:', maxValue); */

        // Function to update the progress bar
        const updateProgress = () => {
          const minVal = parseInt(minRange.value);
          const maxVal = parseInt(maxRange.value);
         /*  console.log('📊 Updating progress - Min:', minVal, 'Max:', maxVal); */

          const leftPercent = (minVal / maxValue) * 100;
          const rightPercent = 100 - (maxVal / maxValue) * 100;
          /* console.log('📊 Progress percentages - Left:', leftPercent, 'Right:', rightPercent); */

          progress.style.left = leftPercent + '%';
          progress.style.right = rightPercent + '%';
        };

        // Function to update displays and manual inputs
        const updateDisplays = (minVal, maxVal) => {
          //console.log('💱 Updating displays - Min:', minVal, 'Max:', maxVal);

          // Format values as currency (show with decimals .00)
          const formatCurrency = (cents) => {
            const dollars = cents / 100;
            return dollars.toFixed(2);
          };

          if (minDisplay) {
            const formattedMin = formatCurrency(minVal);
            /* console.log('🔍 Min display element BEFORE update:', minDisplay);
            console.log('🔍 Min display current text BEFORE:', minDisplay.textContent);
            console.log('🔍 Min display parent element:', minDisplay.parentElement);
            console.log('🔍 Min display computed styles:', window.getComputedStyle(minDisplay)); */
            
            minDisplay.textContent = formattedMin;
            
            // Try alternative update methods
            minDisplay.innerHTML = formattedMin;
            minDisplay.setAttribute('data-value', formattedMin);
            
            // Force re-render by triggering reflow
            minDisplay.style.display = 'none';
            minDisplay.offsetHeight; // Trigger reflow
            minDisplay.style.display = '';
            
            /* console.log('🔍 Min display text AFTER update:', minDisplay.textContent);
            console.log('💰 Updated min display to:', formattedMin, '(from cents:', minVal, ')'); */
          } else {
            console.log('❌ minDisplay element not found');
          }

          if (maxDisplay) {
            const formattedMax = formatCurrency(maxVal);
            /* console.log('🔍 Max display element BEFORE update:', maxDisplay);
            console.log('🔍 Max display current text BEFORE:', maxDisplay.textContent);
            console.log('🔍 Max display parent element:', maxDisplay.parentElement);
            console.log('🔍 Max display computed styles:', window.getComputedStyle(maxDisplay)); */
            
            maxDisplay.textContent = formattedMax;
            
            // Try alternative update methods
            maxDisplay.innerHTML = formattedMax;
            maxDisplay.setAttribute('data-value', formattedMax);
            
            // Force re-render by triggering reflow
            maxDisplay.style.display = 'none';
            maxDisplay.offsetHeight; // Trigger reflow
            maxDisplay.style.display = '';
            
            /* console.log('🔍 Max display text AFTER update:', maxDisplay.textContent);
            //console.log('💰 Updated max display to:', formattedMax, '(from cents:', maxVal, ')'); */
          } else {
            //console.log('❌ maxDisplay element not found');
          }

          if (minManualInput) {
            const formattedMin = formatCurrency(minVal);
            minManualInput.value = formattedMin;
            //console.log('✏️  Updated min manual input to:', formattedMin, '(from cents:', minVal, ')');
          } else {
            //console.log('❌ minManualInput element not found');
          }

          if (maxManualInput) {
            const formattedMax = formatCurrency(maxVal);
            maxManualInput.value = formattedMax;
            //console.log('✏️  Updated max manual input to:', formattedMax, '(from cents:', maxVal, ')');
          } else {
            //console.log('❌ maxManualInput element not found');
          }
        };

        // Handle min range input
        minRange.addEventListener('input', (e) => {
          //console.log('🎚️  Min range input event triggered, value:', e.target.value);
          let minVal = parseInt(e.target.value);
          let maxVal = parseInt(maxRange.value);
          //console.log('🎚️  Current values before validation - Min:', minVal, 'Max:', maxVal);

          // Ensure min doesn't exceed max
          if (minVal >= maxVal) {
            minVal = maxVal - 1;
            e.target.value = minVal;
            //console.log('⚠️  Min value adjusted to:', minVal);
          }

          updateDisplays(minVal, maxVal);
          updateProgress();
        });

        // Handle max range input
        maxRange.addEventListener('input', (e) => {
          //console.log('🎚️  Max range input event triggered, value:', e.target.value);
          let maxVal = parseInt(e.target.value);
          let minVal = parseInt(minRange.value);
          //console.log('🎚️  Current values before validation - Min:', minVal, 'Max:', maxVal);

          // Ensure max doesn't go below min
          if (maxVal <= minVal) {
            maxVal = minVal + 1;
            e.target.value = maxVal;
            //console.log('⚠️  Max value adjusted to:', maxVal);
          }

          updateDisplays(minVal, maxVal);
          updateProgress();
        });

        // Handle manual min input
        if (minManualInput) {
          //console.log('✏️  Binding min manual input events');
          minManualInput.addEventListener('input', (e) => {
            //console.log('✏️  Min manual input event triggered, value:', e.target.value);
            // Input value is already the desired display value, convert to cents for internal use
            let minVal = parseFloat(e.target.value) || 0;
            // Convert to cents for internal range slider (multiply by 100)
            minVal = minVal * 100;
            let maxVal = parseInt(maxRange.value);
            //console.log('✏️  Manual input values before validation - Min (input):', e.target.value, 'Min (cents):', minVal, 'Max:', maxVal);

            // Validate bounds
            if (minVal < 0) minVal = 0;
            if (minVal >= maxVal) minVal = maxVal - 100; // Subtract 100 cents ($1) instead of 1
            if (minVal > maxValue) minVal = maxValue;

            minRange.value = minVal;
            //console.log('✏️  Min manual input adjusted to (cents):', minVal);

            updateDisplays(minVal, maxVal);
            updateProgress();
          });
        } else {
          //console.log('❌ No min manual input found');
        }

        // Handle manual max input
        if (maxManualInput) {
          //console.log('✏️  Binding max manual input events');
          maxManualInput.addEventListener('input', (e) => {
            //console.log('✏️  Max manual input event triggered, value:', e.target.value);
            // Input value is already the desired display value, convert to cents for internal use
            let maxVal = parseFloat(e.target.value) || (maxValue / 100);
            // Convert to cents for internal range slider (multiply by 100)
            maxVal = maxVal * 100;
            let minVal = parseInt(minRange.value);
            //console.log('✏️  Manual input values before validation - Max (input):', e.target.value, 'Max (cents):', maxVal, 'Min:', minVal);

            // Validate bounds
            if (maxVal > maxValue) maxVal = maxValue;
            if (maxVal <= minVal) maxVal = minVal + 100; // Add 100 cents ($1) instead of 1
            if (maxVal < 0) maxVal = 0;

            maxRange.value = maxVal;
            //console.log('✏️  Max manual input adjusted to (cents):', maxVal);

            updateDisplays(minVal, maxVal);
            updateProgress();
          });
        } else {
          //console.log('❌ No max manual input found');
        }

        // Initialize progress bar
        //console.log('🚀 Initializing progress bar');
        updateProgress();

        // Handle price apply button
        const priceApplyBtn = container.querySelector('.c-price-apply-btn');
        if (priceApplyBtn) {/* 
          //console.log('🔘 Binding price apply button'); */
          priceApplyBtn.addEventListener('click', (e) => {
            e.preventDefault();/* 
            //console.log('💲 Price apply button clicked'); */

            const minValue = parseInt(minRange.value);
            const maxValue = parseInt(maxRange.value);/* 
            //console.log('💲 Applying price filter - Min:', minValue, 'Max:', maxValue); */

            // Trigger filter application with price filter flag
            this.applyFilters(null, true);
          });
        } else {
          //console.log('❌ No price apply button found in container');
        }
/* 
        //console.log('✅ Container setup complete for:', filterParam); */
      });
/* 
      //console.log('🏁 bindPriceRangeEvents completed'); */
    }

    showLoading() {
      if (this.loading) {
        this.loading.classList.add('active');
      }
    }

    hideLoading() {
      if (this.loading) {
        this.loading.classList.remove('active');
      }
    }

    showError(message) {
      // Create or update error message
      let errorDiv = this.section.querySelector('.c-filter-error');
      if (!errorDiv) {
        errorDiv = document.createElement('div');
        errorDiv.className = 'c-filter-error';
        errorDiv.style.cssText = `
          background: #FEE2E2;
          border: 1px solid #FECACA;
          color: #DC2626;
          padding: 12px 16px;
          border-radius: 8px;
          margin: 16px 0;
          font-size: 14px;
          text-align: center;
        `;
        this.section.insertBefore(errorDiv, this.section.querySelector('.c-collection-wrapper'));
      }

      errorDiv.textContent = message;
      errorDiv.style.display = 'block';

      // Auto-hide after 5 seconds
      setTimeout(() => {
        if (errorDiv) {
          errorDiv.style.display = 'none';
        }
      }, 5000);
    }

    preserveFilterStates(container) {
      const details = container.querySelectorAll('details');
      const states = {};

      details.forEach((detail, index) => {
        const title = detail.querySelector('summary')?.textContent?.trim();
        if (title) {
          states[title] = detail.open;
        }
      });

      return states;
    }

    restoreFilterStates(container, states) {
      const details = container.querySelectorAll('details');

      details.forEach((detail) => {
        const title = detail.querySelector('summary')?.textContent?.trim();
        if (title && states.hasOwnProperty(title)) {
          detail.open = states[title];
        }
      });
    }
  }

  // Global function to initialize collection filters
  window.initCollectionFilters = function (sectionId) {
    // Remove any existing instances for this section
    if (window.collectionFiltersInstances) {
      const existingInstance = window.collectionFiltersInstances[sectionId];
      if (existingInstance) {
        delete window.collectionFiltersInstances[sectionId];
      }
    } else {
      window.collectionFiltersInstances = {};
    }

    // Create new instance
    /* //console.log('🔧 Creating new CollectionFilters instance for section:', sectionId); */
    window.collectionFiltersInstances[sectionId] = new CollectionFilters(sectionId);
    /* //console.log('✅ CollectionFilters instance created'); */
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-featured-carosel"] && !Shopify.designMode) return;
  try {
    
  // Carousel is handled by CSS animations for better performance
  // Hover pause is handled by CSS :hover pseudo-class

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    console.log('🚀 [C-Hero] Initializing...');

    const section = document.querySelector('.c-hero');
    if (!section) {
      console.error('❌ [C-Hero] Section not found');
      return;
    }

    // Hotspot functionality
    const hotspotTriggers = section.querySelectorAll('[data-action="open-hotspot"]');
    const closeButtons = section.querySelectorAll('[data-action="close-hotspot"]');

    console.log('🔍 [C-Hero] Found elements:', {
      triggers: hotspotTriggers.length,
      closeButtons: closeButtons.length,
    });

    // Open hotspot modal
    hotspotTriggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const targetId = this.getAttribute('data-target');
        const modal = document.getElementById(targetId + '-modal');

        if (modal) {
          modal.classList.add('is-open');
          document.body.style.overflow = 'hidden';
          console.log('✅ [C-Hero] Opened hotspot modal:', targetId);
        }
      });
    });

    // Close hotspot modal
    closeButtons.forEach(function (button) {
      button.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const targetId = this.getAttribute('data-target');
        const modal = document.getElementById(targetId + '-modal');

        if (modal) {
          modal.classList.remove('is-open');
          document.body.style.overflow = '';
          console.log('✅ [C-Hero] Closed hotspot modal:', targetId);
        }
      });
    });

    // Close modal on overlay click
    section.addEventListener('click', function (e) {
      if (e.target.closest('[data-action="close-hotspot"]')) {
        const targetId = e.target.getAttribute('data-target');
        const modal = document.getElementById(targetId + '-modal');

        if (modal) {
          modal.classList.remove('is-open');
          document.body.style.overflow = '';
        }
      }
    });

    // Close modal on escape key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        const openModals = section.querySelectorAll('.c-hotspot-modal.is-open');
        openModals.forEach(function (modal) {
          modal.classList.remove('is-open');
          document.body.style.overflow = '';
        });
      }
    });

    console.log('✅ [C-Hero] Initialization complete!');
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gb-reviews-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('reviews-carousel')) {
    class ReviewsCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        if (!this.track) return;

        this.slides = Array.from(this.track.children);
        this.prevButton = this.querySelector('[data-prev]');
        this.nextButton = this.querySelector('[data-next]');
        this.dots = this.querySelector('[data-dots]');
        this.positions = [0];
        this.index = 0;
        this.ticking = false;

        this.onScroll = this.onScroll.bind(this);
        this.onBlockSelect = this.onBlockSelect.bind(this);

        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.prevButton?.addEventListener('click', () => this.goTo(this.index - 1));
        this.nextButton?.addEventListener('click', () => this.goTo(this.index + 1));
        document.addEventListener('shopify:block:select', this.onBlockSelect);

        this.resizeObserver = new ResizeObserver(() => this.measure());
        this.resizeObserver.observe(this.track);
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      maxScroll() {
        return Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      }

      measure() {
        const max = this.maxScroll();
        const positions = [];

        this.slides.forEach((slide) => {
          const pos = Math.round(Math.min(slide.offsetLeft, max));
          if (!positions.length || pos - positions[positions.length - 1] > 1) positions.push(pos);
        });

        this.positions = positions.length ? positions : [0];
        this.toggleAttribute('data-static', this.positions.length < 2);

        if (this.dots && this.dots.children.length !== this.positions.length) this.renderDots();
        this.update();
      }

      renderDots() {
        const total = this.positions.length;
        this.dots.replaceChildren(
          ...this.positions.map((_, i) => {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'reviews-carousel__dot';
            dot.setAttribute('aria-label', `Go to slide ${i + 1} of ${total}`);
            dot.addEventListener('click', () => this.goTo(i));
            return dot;
          })
        );
      }

      onScroll() {
        if (this.ticking) return;
        this.ticking = true;
        requestAnimationFrame(() => {
          this.update();
          this.ticking = false;
        });
      }

      update() {
        const x = this.track.scrollLeft;
        const max = this.maxScroll();
        let nearest = 0;

        this.positions.forEach((pos, i) => {
          if (Math.abs(pos - x) < Math.abs(this.positions[nearest] - x)) nearest = i;
        });

        this.index = nearest;

        if (this.dots) {
          Array.from(this.dots.children).forEach((dot, i) => {
            dot.setAttribute('aria-current', i === nearest ? 'true' : 'false');
          });
        }

        const atStart = x <= 2;
        const atEnd = x >= max - 2;
        this.prevButton?.setAttribute('aria-disabled', String(atStart));
        this.nextButton?.setAttribute('aria-disabled', String(atEnd));
        this.toggleAttribute('data-at-end', atEnd);
      }

      goTo(i) {
        const index = Math.max(0, Math.min(i, this.positions.length - 1));
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollTo({ left: this.positions[index], behavior: reduce ? 'auto' : 'smooth' });
      }

      onBlockSelect(event) {
        const slide = this.slides.find((s) => s.dataset.blockId === event.detail.blockId);
        if (!slide) return;

        const target = Math.min(slide.offsetLeft, this.maxScroll());
        let nearest = 0;
        this.positions.forEach((pos, i) => {
          if (Math.abs(pos - target) < Math.abs(this.positions[nearest] - target)) nearest = i;
        });
        this.goTo(nearest);
      }
    }

    customElements.define('reviews-carousel', ReviewsCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tribe-recipes"] && !Shopify.designMode) return;
  try {
    
  let recipesSwiper;
  const recipesSelector = '.recipes-slider';

  const initRecipesSwiper = () => {
    const el = document.querySelector(recipesSelector);
    if (!el || recipesSwiper) return;

    const section = el.closest('.tribe-recipes');

    recipesSwiper = new Swiper(recipesSelector, {
      speed: 600,
      slidesPerView: 1.25,
      spaceBetween: 16,
      navigation: {
        nextEl: section.querySelector('.recipes-slider__arrow--next'),
        prevEl: section.querySelector('.recipes-slider__arrow--prev'),
      },
      pagination: {
        el: section.querySelector('.recipes-slider__pagination'),
        clickable: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 2.5,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 3.25,
          spaceBetween: 24,
        },
      },
    });
  };

  initRecipesSwiper();

  } catch(e) { console.error(e); }
})();
})();
